import React from 'react'
import Skeleton from 'react-loading-skeleton';

const PermissionCardSkelton = () => {
    return (
        <>
            <div className="permission-header">
                <Skeleton height={30} width="60%" />
                <div className='d-flex gap-2'>
                    <Skeleton height={20} width={20} />
                    <Skeleton width={80} height={20} />
                </div>
            </div>
            <div className="permission-body">
                <Skeleton count={2} height={60} style={{ marginBottom: 10 }} />
            </div>
        </>
    )
}

export default PermissionCardSkelton
